import { render } from "./sidebarTitle.vue?vue&type=template&id=81957fe6&scoped=true"
import script from "./sidebarTitle.vue?vue&type=script&lang=js"
export * from "./sidebarTitle.vue?vue&type=script&lang=js"

import "./sidebarTitle.vue?vue&type=style&index=0&id=81957fe6&lang=less&scoped=true"

import exportComponent from "/root/workspace/__flow_work/__flow_builds/3fa629ad-4e49-4135-b708-61865bcdea83/workspace/moon_eoR5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81957fe6"]])

export default __exports__